import React from 'react';
export function BottomCTAsSection() {
  return <div className="grid md:grid-cols-2 gap-8" data-id="element-1596">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-center" data-id="element-1597">
        <h3 className="text-xl font-bold text-[#1967a5] mb-3" data-id="element-1598">
          Looking for USED Wire or Sinker EDM?
        </h3>
        <p className="text-gray-600 mb-6" data-id="element-1599">
          Peak Machine Sales is the #1 resource for USED EDM equipment of all
          makes and models throughout North America (and beyond!!)
        </p>
        <a href="#" className="inline-block text-orange font-bold text-lg hover:underline" data-id="element-1600">
          Used EDM Machine Inventory →
        </a>
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-center" data-id="element-1601">
        <h3 className="text-xl font-bold text-[#1967a5] mb-3" data-id="element-1602">
          Looking to sell your well maintained Wire or Sinker EDM?
        </h3>
        <p className="text-gray-600 mb-6" data-id="element-1603">We're interested!</p>
        <a href="/SellingUsedEDM.html" className="inline-block text-orange font-bold text-lg hover:underline" data-id="element-1604">
          Sell USED EDM Machine →
        </a>
      </div>
    </div>;
}